import './App.css';
import { BrowserRouter } from "react-router-dom";
import {persistor, store} from "./Setup/Redux/Store";
import {Provider} from "react-redux";
import React from "react";
import {PersistGate} from "redux-persist/integration/react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {OfficeRoutes} from "./Routes/OfficeRoutes";

const App = () => {

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <BrowserRouter>
                        <OfficeRoutes />
                    </BrowserRouter>
                </LocalizationProvider>
            </PersistGate>
        </Provider>
    );
}

export default App;
